export const SUPER_ADMIN = "Super Admin";
export const ADMIN = "Admin";
export const CSF = "CSF";
export const DIVISION_CONTROLLER = "Division Controller";
export const SALES_SUPERVISOR = "Sales Supervisor";
export const TEAM_MEMBER = "Team Member";
export const EXCEPTIONAL_ADMIN = "Exceptional Admin";